import { FC } from "react";
import ModuleSkeleton from "shared/components/ModuleSkeleton";
import { SmallSkeleton, MediumSkeleton, LargeSkeleton } from "./styled";

const FeaturedCarouselSkeleton: FC = () => {
  return (
    <ModuleSkeleton>
      <SmallSkeleton />
      <MediumSkeleton />
      <LargeSkeleton />
      <MediumSkeleton />
      <SmallSkeleton />
    </ModuleSkeleton>
  );
};

export default FeaturedCarouselSkeleton;
